export enum EClasseComptageParticulaire {
    CP_ISO5 = 13,
    CP_ISO7 = 14,
    CP_ISO8 = 15,
    CP_ClasseA = 16,
    CP_ClasseB = 17,
    CP_ClasseC = 18,
    CP_ClasseD = 19
}